<script setup>
const props = defineProps({
  isDaeunCheck: Boolean,
  birthData: Object,
  birthFiveCnt: Object,
  isApplyDaeun: Boolean,
  hapDataVal: String,
  isLoading: Boolean,
  hapBlDataSky: String,
  hapDataValEarth: String,
  hapBlDataEarth: String,
  rsDataAll: Object,
  toggleProMode: String,
  five: Object,
  langMode: { type: String, default: 'KOR' },
});

const emit = defineEmits(['clickDaeunCheck']);

// 한자 모드 여부 (CHN만 순수 한자, CHNKOR은 한글/한자 모드이므로 라벨은 한글 유지)
const isChnOnly = computed(() => props.langMode === 'CHN');

// 라벨 한자 변환 (CHN 모드에서만 한자)
const labelSajuOhaeng = computed(() => isChnOnly.value ? '四柱 五行' : '사주 오행');
const labelSkyChange = computed(() => isChnOnly.value ? '天干 變化' : '천간 변화');
const labelEarthChange = computed(() => isChnOnly.value ? '地支 變化' : '지지 변화');
const labelGongmangTae = computed(() => isChnOnly.value ? '空亡/胎月' : '공망/태월');
const labelDaeunApply = computed(() => isChnOnly.value ? '大運 適用' : '대운 적용');
const labelBtnDaeun = computed(() => isChnOnly.value ? '大運 適用' : '대운 적용');

const taeTxt = (taeData) => {
  if (props.toggleProMode.value === 'pro') {
    return taeData?.map((item) => props.five.getHanjaTxt2(item?.value)).join('');
  } else {
    return taeData?.map((item) => item?.value).join('');
  }
};

const gongmangTxt = (gongData) => {
  if (props.toggleProMode.value === 'pro') {
    //return gong?.map((item) => five.getHanjaTxt2(item?.value)).join('ㆍ')
    return gongData?.map((item) => props.five.getHanjaTxt2(item?.value)).join('');
  } else {
    return gongData?.map((item) => item?.value).join('');
  }
};
</script>

<template>
  <div class="data-0101-state" :class="{ active: isDaeunCheck }">
    <div class="mobile-inner-wrap">
    <!--'active': daeunCurNum !== transdata.curlucknum--->
    <button class="btn-daeun" @click="emit('clickDaeunCheck')">
      {{ labelBtnDaeun }}<i class="icon-check01" />
    </button>
    <div class="state-row sec-daeun-default">
      <div class="name">{{ labelSajuOhaeng }}</div>
      <div class="five-count-box data">
        <span class="item-box"
          ><em class="txt five03 ganji-txt">木</em
          ><em class="cnt">{{ birthData?.five?.five1?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five01 ganji-txt">火</em
          ><em class="cnt">{{ birthData?.five?.five2?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five05 ganji-txt">土</em
          ><em class="cnt">{{ birthData?.five?.five3?.num }}</em></span
        >

        <span class="item-box"
          ><em class="txt five04 ganji-txt">金</em
          ><em class="cnt">{{ birthData?.five?.five4?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five02 ganji-txt">水</em
          ><em class="cnt">{{ birthData?.five?.five5?.num }}</em></span
        >
      </div>
    </div>
    <div class="state-row sec-daeun-selected">
      <div class="name"><i class="icon-frame" /><span>{{ labelDaeunApply }}</span></div>
      <div class="five-count-box data">
        <span class="item-box"
          ><em class="txt five03 ganji-txt">木</em
          ><em class="cnt">{{ birthFiveCnt?.five1?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five01 ganji-txt">火</em
          ><em class="cnt">{{ birthFiveCnt?.five2?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five05 ganji-txt">土</em
          ><em class="cnt">{{ birthFiveCnt?.five3?.num }}</em></span
        >

        <span class="item-box"
          ><em class="txt five04 ganji-txt">金</em
          ><em class="cnt">{{ birthFiveCnt?.five4?.num }}</em></span
        >
        <span class="item-box"
          ><em class="txt five02 ganji-txt">水</em
          ><em class="cnt">{{ birthFiveCnt?.five5?.num }}</em></span
        >
      </div>
    </div>
    <!-- <div class="state-row"> -->
    <div class="state-row" :class="{ 'sec-daeun-default': isApplyDaeun }">
      <div class="name">{{ labelSkyChange }}</div>
      <div class="data" :class="{ 'none-data': hapDataVal === '' }">
        {{ hapDataVal || '원국 천간변화가 없습니다.' }}
      </div>
    </div>
    <div v-if="isApplyDaeun" class="state-row sec-daeun-selected">
      <div class="name"><i class="icon-frame" /><span>{{ labelDaeunApply }}</span></div>
      <div class="data" :class="{ 'none-data': !hapBlDataSky }">
        {{ isLoading ? '' : hapBlDataSky || '원국 천간변화가 없습니다.' }}
      </div>
    </div>

    <!-- <div class="state-row"> -->
    <div class="state-row" :class="{ 'sec-daeun-default': isApplyDaeun }">
      <div class="name">{{ labelEarthChange }}</div>
      <div class="data" :class="{ 'none-data': hapDataValEarth === '' }">
        {{ hapDataValEarth || '원국 지지변화가 없습니다.' }}
      </div>
    </div>
    <div v-if="isApplyDaeun" class="state-row sec-daeun-selected">
      <div class="name"><i class="icon-frame" /><span>{{ labelDaeunApply }}</span></div>
      <div class="data" :class="{ 'none-data': !hapBlDataEarth }">
        {{ isLoading ? '' : hapBlDataEarth || '원국 지지변화가 없습니다.' }}
      </div>
    </div>
    <div class="state-row">
      <div class="name">{{ labelGongmangTae }}</div>
      <div class="data">
        <!-- {{ gongDataVal }} -->
        {{ `${gongmangTxt(rsDataAll.gongmang)} / ${taeTxt(rsDataAll.taewon)}` }}
      </div>
    </div>
    <!-- <div class="state-row">
                      <div class="name">
                        태월
                      </div>
                      <div class="data">
                        {{ TaeDataVal }}
                      </div>
                    </div> -->
    <!-- <div class="state-row">
                      <div class="name">
                        MBTI
                      </div>
                      <div class="data">
                        <span class="bg-point">로그인 후 사주로 보는 MBTI</span>
                      </div>
                    </div> -->
    </div>
  </div>
</template>
